import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured/administration/user-groups/$groupId/members/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/administration/user-groups/$groupId/members/$page/$limit',
      params: { groupId: params.groupId, page: '1', limit: '10' },
    });
  },
});
